export const environment = {
  production: true,
  envName: 'prod',
  dfnEntryPoint: 'https://api.gast.de/auth/saml/login?'
};
